import React from 'react';
import FontawesomeIconContainer from '../../Componant/Icons/FontawesomeIcon';

const FontawesomeIcon = () => {
  return (
    <div className='page-body'>
      <FontawesomeIconContainer />
    </div>
  );
};

export default FontawesomeIcon;
